import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Select, Input, Space, Tag, Modal, message, Tooltip } from 'antd';
import { EyeOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useAntdTable, useSize, useDebounce } from 'ahooks';
import { useDispatch } from 'react-redux';
import { setBreadcrumbList } from '../../../store/menuInfo/menuInfo';
import apis from '../../../apis';
import PlanEdit from '../PlanEdit';
import MessageModal from '../../../components/MessageModal';
import './index.scss';

const { Option } = Select;
const { TextArea } = Input;

const IconView = (
    <svg t="1704265207410" viewBox="0 0 1024 1024" version="1.1" p-id="4261" width="12" height="12" style={{ cursor: 'pointer' }}>
        <path d="M896 64H128c-35.296 0-64 28.704-64 64v768c0 35.296 28.704 64 64 64h592a32 32 0 1 0 0-64H128V128h768v592a32 32 0 1 0 64 0V128c0-35.296-28.704-64-64-64z" p-id="4262"></path>
        <path d="M791.744 746.496A206.752 206.752 0 0 0 832 624c0-114.688-93.312-208-208-208S416 509.312 416 624s93.312 208 208 208a206.752 206.752 0 0 0 122.496-40.256l110.88 110.88a31.904 31.904 0 0 0 45.248 0 31.968 31.968 0 0 0 0-45.248l-110.88-110.88zM480 624c0-79.392 64.608-144 144-144s144 64.608 144 144-64.608 144-144 144-144-64.608-144-144zM800 264a32 32 0 0 0-32-32H256a32 32 0 0 0 0 64h512a32 32 0 0 0 32-32zM256 422.656a32 32 0 0 0 0 64h96a32 32 0 0 0 0-64H256z" p-id="4263"></path>
    </svg>
);

const IconEdit = (
    <svg t="1704265355134" viewBox="0 0 1024 1024" version="1.1" p-id="5249" width="12" height="12" style={{ cursor: 'pointer' }}>
        <path d="M867.388235 173.176471l-102.4-108.42353c-24.094118-30.117647-60.235294-30.117647-84.329411 0l-54.211765 60.235294-457.788235 499.952941c-6.023529 6.023529-6.023529 12.047059-6.02353 18.070589l-36.141176 192.752941c-6.023529 24.094118 12.047059 42.164706 36.141176 36.141176l180.705882-36.141176c6.023529 0 12.047059-6.023529 18.070589-12.047059l427.670588-469.835294 84.329412-90.352941c18.070588-30.117647 18.070588-66.258824-6.02353-90.352941z m-548.141176 608.37647l-126.494118 24.094118 24.094118-132.517647 42.164706-48.188236 102.4 114.447059-42.164706 42.164706z m84.329412-96.37647l-102.4-114.447059 343.341176-373.458824 102.4 108.42353-343.341176 379.482353z m385.505882-415.62353l-108.423529-114.447059 42.164705-48.188235 108.42353 114.447059-42.164706 48.188235zM30.117647 926.117647h963.764706v60.235294h-963.764706z" fill="#222222" p-id="5250"></path>
    </svg>
);

const IconDelete = (
    <svg t="1705891931298" viewBox="0 0 1024 1024" version="1.1" p-id="5147" width="14" height="14" style={{ cursor: 'pointer' }}>
        <path d="M607.897867 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L575.903242 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 351.94087C639.892491 753.593818 625.61532 768.043004 607.897867 768.043004z" fill="#575B66" p-id="5148"></path>
        <path d="M415.930119 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L383.935495 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625 17.717453 0 31.994625 14.277171 31.994625 31.994625l0 351.94087C447.924744 753.593818 433.647573 768.043004 415.930119 768.043004z" fill="#575B66" p-id="5149"></path>
        <path d="M928.016126 223.962372l-159.973123 0L768.043004 159.973123c0-52.980346-42.659499-95.983874-95.295817-95.983874L351.94087 63.989249c-52.980346 0-95.983874 43.003528-95.983874 95.983874l0 63.989249-159.973123 0c-17.717453 0-31.994625 14.277171-31.994625 31.994625s14.277171 31.994625 31.994625 31.994625l832.032253 0c17.717453 0 31.994625-14.277171 31.994625-31.994625S945.73358 223.962372 928.016126 223.962372zM319.946246 159.973123c0-17.545439 14.449185-31.994625 31.994625-31.994625l320.806316 0c17.545439 0 31.306568 14.105157 31.306568 31.994625l0 63.989249L319.946246 223.962372 319.946246 159.973123 319.946246 159.973123z" fill="#575B66" p-id="5150"></path>
        <path d="M736.048379 960.010751 288.123635 960.010751c-52.980346 0-95.983874-43.003528-95.983874-95.983874L192.139761 383.591466c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 480.435411c0 17.717453 14.449185 31.994625 31.994625 31.994625l448.096758 0c17.717453 0 31.994625-14.277171 31.994625-31.994625L768.215018 384.795565c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 479.231312C832.032253 916.835209 789.028725 960.010751 736.048379 960.010751z" fill="#575B66" p-id="5151"></path>
    </svg>
);

const IconList = (
    <svg t="1768371846589" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4683" width="16" height="16" style={{ cursor: 'pointer' }}>
        <path d="M704 288h130.986667c8.704 0 15.872 2.645333 21.546666 7.978667a35.114667 35.114667 0 0 1 10.496 20.992L886.016 512h-64l-16-160H704v96a31.146667 31.146667 0 0 1-8.96 23.04 31.146667 31.146667 0 0 1-23.04 8.96 31.146667 31.146667 0 0 1-23.04-8.96 31.146667 31.146667 0 0 1-8.96-23.04V352H384v96a31.146667 31.146667 0 0 1-8.96 23.04 31.146667 31.146667 0 0 1-23.04 8.96 31.146667 31.146667 0 0 1-23.04-8.96 31.146667 31.146667 0 0 1-8.96-23.04V352H217.984l-50.986667 512h344.96v64H130.986667a30.378667 30.378667 0 0 1-23.466667-10.496 28.885333 28.885333 0 0 1-7.466667-24.533333L157.013333 317.013333a35.328 35.328 0 0 1 10.496-20.992 30.08 30.08 0 0 1 21.504-7.978666H320v-22.016c1.365333-57.344 20.010667-105.002667 56.021333-143.018667 35.968-37.973333 81.322667-57.642667 135.978667-59.008 54.698667 1.365333 100.010667 21.034667 136.021333 59.008 35.968 37.973333 54.613333 85.674667 55.978667 143.018667v22.016z m-64 0v-22.016c-0.64-39.338667-13.141333-72.021333-37.504-98.005333-24.32-26.026667-54.485333-39.338667-90.496-40.021334-36.010667 0.682667-66.176 13.994667-90.496 40.021334-24.32 26.026667-36.821333 58.666667-37.504 98.005333v22.016h256z m200.96 484.010667L768 697.984v230.016a31.146667 31.146667 0 0 1-8.96 23.04 31.146667 31.146667 0 0 1-23.04 8.96 31.146667 31.146667 0 0 1-23.04-8.96 31.146667 31.146667 0 0 1-8.96-23.04v-230.016l-72.96 74.026667c-9.386667 8.661333-19.882667 11.306667-31.530667 7.978666a29.781333 29.781333 0 0 1-22.016-22.485333 30.848 30.848 0 0 1 7.509334-30.506667l128-128a31.616 31.616 0 0 1 22.997333-10.026666c8.661333 0 16.341333 3.370667 23.04 10.026666l128 128a30.933333 30.933333 0 0 1 7.466667-30.506667 29.738667 29.738667 0 0 1-22.016-22.485333c-11.690667 3.328-22.186667 0.682667-31.488-7.978666z" fill="#000000" fillOpacity=".65" p-id="4684"></path>
    </svg>
);

const IconUnlist = (
    <svg t="1768371865755" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4944" width="16" height="16" style={{ cursor: 'pointer' }}>
        <path d="M704 288h130.986667c8.704 0 15.872 2.645333 21.546666 7.978667a35.114667 35.114667 0 0 1 10.496 20.992L886.016 512h-64l-16-160H704v96a31.146667 31.146667 0 0 1-8.96 23.04 31.146667 31.146667 0 0 1-23.04 8.96 31.146667 31.146667 0 0 1-23.04-8.96 31.146667 31.146667 0 0 1-8.96-23.04V352H384v96a31.146667 31.146667 0 0 1-8.96 23.04 31.146667 31.146667 0 0 1-23.04 8.96 31.146667 31.146667 0 0 1-23.04-8.96 31.146667 31.146667 0 0 1-8.96-23.04V352H217.984l-50.986667 512h344.96v64H130.986667a30.378667 30.378667 0 0 1-23.466667-10.496 28.885333 28.885333 0 0 1-7.466667-24.533333L157.013333 317.013333a35.328 35.328 0 0 1 10.496-20.992 30.08 30.08 0 0 1 21.504-7.978666H320v-22.016c1.365333-57.344 20.010667-105.002667 56.021333-143.018667 35.968-37.973333 81.322667-57.642667 135.978667-59.008 54.698667 1.365333 100.010667 21.034667 136.021333 59.008 35.968 37.973333 54.613333 85.674667 55.978667 143.018667v22.016z m-64 0v-22.016c-0.64-39.338667-13.141333-72.021333-37.504-98.005333-24.32-26.026667-54.485333-39.338667-90.496-40.021334-36.010667 0.682667-66.176 13.994667-90.496 40.021334-24.32 26.026667-36.821333 58.666667-37.504 98.005333v22.016h256z m200.96 475.989333a32.853333 32.853333 0 0 1 32-8.533333c12.032 2.986667 19.541333 10.496 22.528 22.528a30.634667 30.634667 0 0 1-8.533333 31.018667l-128 128a31.658667 31.658667 0 0 1-22.997334 9.984 31.658667 31.658667 0 0 1-22.997333-9.984l-128-128a30.933333 30.933333 0 0 1-7.466667-30.506667 29.738667 29.738667 0 0 1 22.016-22.485333c11.648-3.328 22.144-0.682667 31.488 7.978666l72.96 74.026667V608a31.146667 31.146667 0 0 1 9.002667-23.04 31.146667 31.146667 0 0 1 23.04-8.96 31.146667 31.146667 0 0 1 22.997333 8.96c5.973333 6.016 8.96 13.696 8.96 23.04v230.016l73.045334-74.026667z" fill="#000000" fillOpacity=".65" p-id="4945"></path>
    </svg>
);

const IconPublish = (
    <svg t="1768371909137" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6127" width="16" height="16" style={{ cursor: 'pointer' }}>
        <path d="M822.9 954.7c-7 0-14-1.8-20.3-5.4L514.4 782.8c-12.5-7.2-16.8-23.2-9.6-35.7 7.2-12.5 23.2-16.8 35.7-9.6L813.4 895l92.2-765-776.3 370.1L465.4 693c12.5 7.2 16.8 23.1 9.7 35.6-7.2 12.5-23.1 16.8-35.6 9.7L84 534.4c-12.6-7.3-20.4-20.7-20.4-35.2 0-14.5 7.8-27.9 20.3-35.2l1.8-1L900.6 74.6c12.3-6.6 27.3-6.4 39.5 0.6 12.5 7.2 20.3 20.7 20.3 35.2l-0.2 3.1L863.4 916c-0.7 13.7-8.3 26.3-20.2 33.2-6.3 3.6-13.3 5.5-20.3 5.5z" fill="#7D7D7D" p-id="6128"></path>
        <path d="M437.5 928.2c-14.4 0-26.1-11.7-26.1-26.1V748.2c0-12.4 4.2-24.6 11.8-34.4l486-618.4c8.9-11.3 25.3-13.3 36.7-4.4 11.3 8.9 13.3 25.3 4.4 36.7L464.4 745.9c-0.5 0.6-0.7 1.4-0.7 2.2V902c-0.1 14.5-11.8 26.2-26.2 26.2z" fill="#7D7D7D" p-id="6129"></path>
    </svg>
);

const PlanList = () => {
    const [viewState, setViewState] = useState('list'); // 'list' | 'add' | 'edit' | 'view'
    const [currentPlanId, setCurrentPlanId] = useState(null);
    const [publishModalOpen, setPublishModalOpen] = useState(false);
    const [publishRecord, setPublishRecord] = useState(null);
    const [publishComment, setPublishComment] = useState('');
    const dispatch = useDispatch();

    const refTable = useRef(null);
    const refHeader = useRef(null);
    const size = useSize(refTable);
    const headerSize = useSize(refHeader);

    useEffect(() => {
        if (viewState === 'list') {
            dispatch(setBreadcrumbList([{ title: '充值方案' }, { title: 'TOB方案管理' }]));
        }
    }, [viewState, dispatch]);

    const [form] = Form.useForm();

    const getTableData = ({ current, pageSize }, formData) => {
        // Map form data to API params
        const params = {
            page: current,
            page_size: pageSize,
            ...formData
        };
        // Remove undefined/null/empty string values
        Object.keys(params).forEach(key => {
            if (params[key] === undefined || params[key] === null || params[key] === '') {
                delete params[key];
            }
        });

        return apis.getTopupPlanList(params).then(res => {
            if (res.code === 200) {
                return {
                    total: res.data?.total_count || 0,
                    list: res.data?.data || []
                };
            }
            message.error(res.message || '获取列表失败');
            return {
                total: 0,
                list: []
            };
        }).catch(() => {
            message.error('获取列表失败');
            return {
                total: 0,
                list: []
            };
        });
    };

    const { tableProps, search, refresh } = useAntdTable(getTableData, {
        form,
        defaultPageSize: 10,
        manual: true,
    });

    const { submit, reset } = search;

    const topup_plan_name = Form.useWatch('topup_plan_name', form);
    const debounced_topup_plan_name = useDebounce(topup_plan_name, { wait: 500 });

    useEffect(() => {
        submit();
    }, [
        Form.useWatch('topup_plan_type_code', form),
        Form.useWatch('topup_plan_status_code', form),
        Form.useWatch('last_ver_status_code', form),
        debounced_topup_plan_name,
    ]);

    const handleAdd = () => {
        setViewState('add');
        setCurrentPlanId(null);
    };

    const handleEdit = (record) => {
        setCurrentPlanId(record.topup_plan_id);
        setViewState('edit');
    };

    const handleView = (record) => {
        setCurrentPlanId(record.topup_plan_id);
        setViewState('view');
    };

    const handleDelete = (record) => {
        MessageModal({
            type: "warning",
            title: '删除',
            noIcon: true,
            description: `确定要删除方案 "${record.topup_plan_name}" 吗？`,
            onOk: () => {
                apis.deleteTopupPlan({ topup_plan_id: record.topup_plan_id }).then(res => {
                    if (res.code === 200) {
                        message.success('删除成功');
                        refresh();
                    } else {
                        message.error(res.message || '删除失败');
                    }
                }).catch(() => {
                    message.error('删除失败');
                });
            }
        });
    };

    const handleSubmitAudit = (record) => {
        setPublishRecord(record);
        setPublishComment('');
        setPublishModalOpen(true);
    };

    const handlePublishConfirm = () => {
        apis.publishTopupPlan({
            topup_plan_id: publishRecord?.topup_plan_id,
            publish_comment: publishComment
        }).then(res => {
            if (res.code === 200) {
                message.success('发布成功');
                setPublishModalOpen(false);
                refresh();
            } else {
                message.error(res.message || '发布失败');
            }
        }).catch(() => {
            message.error('发布失败');
        });
    };

    const handleListAction = (record, type) => {
        const isList = type === 'list';
        const actionText = isList ? '上架' : '下架';
        
        MessageModal({
            type: actionText === "上架" ? undefined : "warning",
            title: actionText,
            noIcon: true,
            description: `确定要${actionText}方案 "${record.topup_plan_name}" 吗？`,
            onOk: () => {
                return apis.toggleTopupPlanListing({ topup_plan_id: record.topup_plan_id, action: type }).then(res => {
                    if (res.code === 200) {
                        message.success(`${actionText}成功`);
                        refresh();
                    } else {
                        message.error(res.message || `${actionText}失败`);
                    }
                }).catch(() => {
                    message.error(`${actionText}失败`);
                });
            }
        });
    };

    if (viewState === 'add' || viewState === 'edit' || viewState === 'view') {
        return <PlanEdit 
            id={currentPlanId} 
            type={viewState}
            onBack={() => {
                setViewState('list');
                refresh();
            }} 
        />;
    }

    const columns = [
        {
            title: '方案类别',
            dataIndex: 'topup_plan_type_code',
            align: 'center',
            render: (text) => text === 'ENTERPRISE_EDITION' ? '企业版' : (text === 'PERSONAL_EDITION' ? '个人版' : text),
        },
        {
            title: '方案编号',
            dataIndex: 'topup_plan_code',
            align: 'center',
        },
        {
            title: '方案名称',
            dataIndex: 'topup_plan_name',
            align: 'center',
        },
        {
            title: '权益点',
            dataIndex: 'equity_point',
            align: 'center',
        },
        {
            title: '原价 (元)',
            dataIndex: 'original_price',
            align: 'center',
            render: (text) => `¥${Number(text).toFixed(2)}`,
        },
        {
            title: '折扣价 (元)',
            dataIndex: 'discount_price',
            align: 'center',
            render: (text) => text ? `¥${Number(text).toFixed(2)}` : '-',
        },
        {
            title: '方案状态',
            dataIndex: 'topup_plan_status_code',
            align: 'center',
            render: (text) => {
                const map = {
                    'LISTED': { color: 'green', text: '已上架' },
                    'NOT_LISTED': { color: 'default', text: '未上架' },
                    'DELETED': { color: 'red', text: '已删除' },
                };
                return <Tag color={map[text]?.color}>{map[text]?.text || text}</Tag>;
            }
        },
        {
            title: '上架版本',
            dataIndex: 'list_ver_no',
            align: 'center',
            render: (text) => text || '-',
        },
        {
            title: '最新版本及状态',
            key: 'last_ver_info',
            align: 'center',
            width: 140,
            render: (_, record) => {
                const text = record.last_ver_status_code;
                const map = {
                    'EDITING': { color: 'blue', text: '待发布' },
                    'AUDITING': { color: 'orange', text: '审核中' },
                    'UNDER_REVIEW': { color: 'orange', text: '审核中' },
                    'PUBLISHED': { color: 'green', text: '已发布' },
                    'REJECTED': { color: 'red', text: '已驳回' },
                };
                return (
                    <Space>
                        <span>{record.last_ver_no || '-'}</span>
                        <Tag color={map[text]?.color}>{map[text]?.text || text}</Tag>
                    </Space>
                );
            }
        },
        {
            title: '上架时间',
            dataIndex: 'list_time',
            align: 'center',
            render: (text) => text || '-',
        },
        {
            title: '创建人',
            dataIndex: 'created_by_name',
            align: 'center',
            render: (text) => text || '-',
        },
        {
            title: '更新时间',
            dataIndex: 'last_updated_time',
            align: 'center',
        },
        {
            title: '操作',
            key: 'action',
            width: 120,
            align: 'center',
            render: (_, record) => {
                const { topup_plan_status_code, last_ver_status_code, list_ver_no, last_ver_no } = record;
                const isDeleted = topup_plan_status_code === 'DELETED';
                const isListed = topup_plan_status_code === 'LISTED';
                const isNotListed = topup_plan_status_code === 'NOT_LISTED';
                
                // 1. 查看: 全部可查看
                const canView = true;

                // 2. 编辑: 最新版本状态 <> 审核中
                const canEdit = !isDeleted && last_ver_status_code !== 'AUDITING';

                // 3. 发布: 最新版本状态 = 待发布 或者 最新版本状态 = 已驳回
                const canPublish = !isDeleted && (last_ver_status_code === 'EDITING' || last_ver_status_code === 'REJECTED');

                // 4. 上架: 有已发布版本 并且 （最新已发布版本号 > 上架版本号 或者 方案状态 = 未上架）
                // 注意：这里假设 last_ver_status_code === 'PUBLISHED' 代表“有已发布版本”且该版本为最新
                const hasPublishedVersion = last_ver_status_code === 'PUBLISHED';
                const isNewerVersion = last_ver_no !== list_ver_no;
                const canList = !isDeleted && hasPublishedVersion && (isNotListed || isNewerVersion);

                // 5. 下架: 方案状态 = 已上架
                const canUnlist = !isDeleted && isListed;

                // 6. 删除: 方案状态 = 未上架
                const canDelete = !isDeleted && isNotListed;

                return (
                    <div className="tableTagsBox">
                        {/* 查看 */}
                        <Tooltip title="查看">
                            <span onClick={() => handleView(record)} className="action-icon">
                                {IconView}
                            </span>
                        </Tooltip>

                        {/* 编辑 */}
                        {canEdit && (
                            <Tooltip title="编辑">
                                <span onClick={() => handleEdit(record)} className="action-icon">
                                    {IconEdit}
                                </span>
                            </Tooltip>
                        )}

                        {/* 发布 */}
                        {canPublish && (
                            <Tooltip title="发布">
                                <span onClick={() => handleSubmitAudit(record)} className="action-icon">
                                    {IconPublish}
                                </span>
                            </Tooltip>
                        )}

                        {/* 上架 */}
                        {canList && (
                            <Tooltip title="上架">
                                <span onClick={() => handleListAction(record, 'list')} className="action-icon">
                                    {IconList}
                                </span>
                            </Tooltip>
                        )}

                        {/* 下架 */}
                        {canUnlist && (
                            <Tooltip title="下架">
                                <span onClick={() => handleListAction(record, 'unlist')} className="action-icon">
                                    {IconUnlist}
                                </span>
                            </Tooltip>
                        )}

                        {/* 删除 */}
                        {canDelete && (
                            <Tooltip title="删除">
                                <span onClick={() => handleDelete(record)} className="action-icon">
                                    {IconDelete}
                                </span>
                            </Tooltip>
                        )}
                    </div>
                );
            },
        },
    ];

    return (
        <div className="topupPlanListContent" ref={refTable}>
            <div className="filterItemsBox" ref={refHeader}>
                <div className="filterItemsContent">
                    <Form form={form} component={false}>
                        <div className="filterItem">
                            <span className="filterItemSpan">方案类别</span>
                            <Form.Item name="topup_plan_type_code" noStyle>
                                <Select allowClear placeholder="全部" style={{ width: '180px' }}>
                                    <Option value="ENTERPRISE_EDITION">企业版</Option>
                                    <Option value="PERSONAL_EDITION">个人版</Option>
                                </Select>
                            </Form.Item>
                        </div>

                        <div className="filterItem">
                            <span className="filterItemSpan">方案状态</span>
                            <Form.Item name="topup_plan_status_code" noStyle>
                                <Select allowClear placeholder="全部" style={{ width: '180px' }}>
                                    <Option value="LISTED">已上架</Option>
                                    <Option value="NOT_LISTED">未上架</Option>
                                    <Option value="DELETED">已删除</Option>
                                </Select>
                            </Form.Item>
                        </div>

                        <div className="filterItem">
                            <span className="filterItemSpan">最新版本状态</span>
                            <Form.Item name="last_ver_status_code" noStyle>
                                <Select allowClear placeholder="全部" style={{ width: '180px' }}>
                                    <Option value="EDITING">待发布</Option>
                                    <Option value="UNDER_REVIEW">审核中</Option>
                                    <Option value="PUBLISHED">已发布</Option>
                                    <Option value="REJECTED">已驳回</Option>
                                </Select>
                            </Form.Item>
                        </div>

                        <div className="filterItem">
                            <span className="filterItemSpan">方案名称</span>
                            <Form.Item name="topup_plan_name" noStyle>
                                <Input placeholder="请输入方案名称" allowClear style={{ width: '180px' }} />
                            </Form.Item>
                        </div>

                        <Button type="primary" className="btn" onClick={handleAdd}>新增方案</Button>
                    </Form>
                </div>
            </div>

            <div className="tableContent">
                <Table
                    columns={columns}
                    rowKey="topup_plan_id"
                    {...tableProps}
                    className="myFormTable"
                    bordered={true}
                    scroll={{ x: 1300, y: size?.height ? size.height - (headerSize?.height || 0) - 180 + 'px' : undefined }}
                />
            </div>
            
            <Modal
                title="发布"
                open={publishModalOpen}
                onCancel={() => setPublishModalOpen(false)}
                footer={null}
            >
                <div style={{ marginBottom: '8px' }}>发布说明</div>
                <TextArea
                    rows={4}
                    placeholder="请输入发布说明"
                    value={publishComment}
                    onChange={(e) => setPublishComment(e.target.value)}
                    style={{ marginBottom: '24px' }}
                />
                <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                    <Button onClick={() => setPublishModalOpen(false)}>取消</Button>
                    <Button type="primary" onClick={handlePublishConfirm}>提交发布审批</Button>
                </div>
            </Modal>
        </div>
    );
};

export default PlanList;
